import { UserData } from 'models/Blip/Index'

export class UserDataSingleton{
    static instance: UserData;

    constructor() {}

    static setInstance(userData: UserData): void {
      if (!this.instance) {
        this.instance = userData;
      }
    }
}